export default Object.freeze({
  DEFAULT: 'DEFAULT',
  LINKER: 'LINKER'
});
//# sourceMappingURL=ToolType.js.map